import { cn } from "@gettactic/helpers";

export const InputLabel = ({
  children,
  className,
  htmlFor
}: {
  children: React.ReactNode;
  className?: string;
  htmlFor: string;
}) => {
  return (
    <label 
      className={cn("text-center font-inter font-medium text-gray-800 text-sm", className)} 
      htmlFor={htmlFor}
    >
      {children}
    </label>
  );
};